/**
 * GIỜ MÁY CHỦ cho thanh trạng thái dưới.
 *
 * ─────────────────────────────────────────────────────────────────────────────────────
 * 🔴 VÌ SAO KHÔNG DÙNG THẲNG `new Date()`
 *
 * Đặc tả ghi *"Giờ máy chủ 15:42:07"*. `new Date()` là **giờ của máy người dùng**, không
 * phải giờ máy chủ. Vẽ giờ trình duyệt dưới nhãn "Giờ máy chủ" thì:
 *
 *   - máy người trực ca lệch 4 phút ⇒ họ đối chiếu mốc `raisedAt` của cảnh báo và thấy sai
 *   - và **không có gì kêu lên cả** — nó trông đúng, mãi mãi
 *
 * Đúng cái họ hàng với *"một hình thay thế trông hợp lý thì không bao giờ được thay"* và
 * với `switchPos` mặc định `OFF`. **Một con số sai mà trông đúng thì tệ hơn không có số.**
 * ─────────────────────────────────────────────────────────────────────────────────────
 *
 * Cách lấy: header `Date` của **mọi** phản hồi API — máy chủ đã gửi nó sẵn, không phải thêm
 * đường mới, không phải sửa máy chủ.
 *
 * ⚠ ĐỘ CHÍNH XÁC: header `Date` chỉ tới **giây**, và không trừ được thời gian đi đường.
 *   Sai số thực tế ~±1 giây. Đủ cho một thanh trạng thái; **không** đủ để làm mốc so
 *   sự kiện. Đừng ai lấy hàm này đi đóng dấu thời gian.
 *
 * ⚠ CHỖ KHÔNG LẤY ĐƯỢC: nếu web chạy khác gốc với API (`VITE_API_BASE` trỏ sang tên miền
 *   khác) thì `Date` **không** nằm trong danh sách header CORS cho đọc, trừ khi máy chủ khai
 *   `Access-Control-Expose-Headers: Date`. Lúc dev có proxy Vite nên cùng gốc, đọc được.
 *   Không đọc được ⇒ `theoMayChu = false` ⇒ chỗ vẽ phải **nói ra là giờ máy**, không được
 *   im lặng vẽ giờ trình duyệt dưới nhãn máy chủ. *(Chưa rõ phải trông khác tốt.)*
 */

import { useEffect, useState } from 'react';

/** `null` = chưa từng đọc được header `Date`. Không phải 0 — 0 nghĩa là "đo được, và bằng nhau". */
let lechMs: number | null = null;

/** Gọi từ `api.ts` sau mỗi `fetch` thành công. Rẻ: đọc một header, so một phép trừ. */
export function ghiNhanGioTuPhanHoi(res: Response): void {
  let h: string | null = null;
  try { h = res.headers.get('Date'); } catch { return; }
  if (!h) return;
  const t = Date.parse(h);
  if (!Number.isFinite(t)) return;
  lechMs = t - Date.now();
}

/** Cho phép kiểm và cho chỗ chẩn đoán đọc. `null` = chưa đo được lần nào. */
export function lechGioMs(): number | null {
  return lechMs;
}

export interface GioHienThi {
  /** `15:42:07` */
  gio: string;
  /** `true` = đã đo được lệch giờ từ máy chủ. `false` = đang là giờ MÁY NÀY. */
  theoMayChu: boolean;
}

export function docGio(bayGio: number = Date.now()): GioHienThi {
  const theoMayChu = lechMs !== null;
  const d = new Date(bayGio + (lechMs ?? 0));
  const hai = (n: number) => String(n).padStart(2, '0');
  return { gio: `${hai(d.getHours())}:${hai(d.getMinutes())}:${hai(d.getSeconds())}`, theoMayChu };
}

/** Nhịp một giây. Chỉ dùng ở thanh trạng thái — đừng gắn vào bảng đang cuộn. */
export function useGioMayChu(): GioHienThi {
  const [gio, setGio] = useState<GioHienThi>(() => docGio());
  useEffect(() => {
    const t = window.setInterval(() => setGio(docGio()), 1000);
    return () => window.clearInterval(t);
  }, []);
  return gio;
}
